export const BASE_ENDPOINT = process.env.REACT_APP_API_URL;
export const BASE_SPRING_ENDPOINT = process.env.REACT_APP_SPRING_API_URL;
export const BASE_DJANGO_ENDPOINT = process.env.REACT_APP_DJANGO_API_URL;
export const CM_PULL_BOOKING_ENDPOINT =
  process.env.REACT_APP_SPRING_API_PULL_CM_BOOKING_URL;
export const razorPayKey = process.env.REACT_APP_RAZORPAY_PUBLIC_KEY;
